<template>
    <b-sidebar
        id="group-form-sidebar"
        :visible="isFloorplanFormSidebarActive"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        backdrop
        no-header
        right
        @shown="getData(building)"
        @hidden="resetForm(resetData)"
        @update:visible="val => $emit('update:is-floorplan-form-sidebar-active', val)"
    >
        <template #default="{ hide }">
            <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
                <h5 class="mb-0">Floor Plan Form</h5>
                <feather-icon
                class="ml-1 cursor-pointer"
                icon="XIcon"
                size="16"
                @click="hide"
                />
            </div>

            <validation-observer
                ref="refFormObserver"
                v-slot="{ handleSubmit }"
            >
                <b-form
                class="p-2"
                @submit.prevent="handleSubmit(onSubmit)"
                @reset.prevent="resetForm"
                >
                <b-tabs content-class="mt-1" v-if="langsData.length > 0">
                    <b-tab
                    v-for="(lang, key) in langsData"
                    :key="'tab-' + key"
                    :title="lang.name"
                    >
                    <validation-provider
                        :name="'title_' + lang.code"
                        rules="required"
                        v-slot="validationContext"
                    >
                        <b-form-group
                        :label="'Title (' + lang.code + ')'"
                        :label-for="'title_' + lang.code"
                        >
                        <b-form-input
                            :id="'title_' + lang.code"
                            v-model="Data.title[lang.code]"
                            :state="getValidationState(validationContext)"
                            :placeholder="'Title (' + lang.code + ')'"
                            trim
                            autofocus
                        />
                        <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                    </b-tab>
                </b-tabs>

                <validation-provider name="image" rules="required" v-slot="validationContext">
                    <b-form-group label="Upload Image" label-for="imageUpload">
                    <b-form-file
                        id="imageUpload"
                        v-model="Data.image"
                        :state="getValidationState(validationContext)"
                        placeholder="Choose an image..."
                        browse-text="Browse"
                    />
                    <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                    </b-form-group>
                </validation-provider>

                <div class="d-flex mt-2">
                    <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mr-2"
                    type="submit"
                    >
                    Submit
                    </b-button>
                    <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    type="button"
                    variant="outline-secondary"
                    @click="hide"
                    >
                    Cancel
                    </b-button>
                </div>
                </b-form>
            </validation-observer>
        </template>
    </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton,
  BTabs, BTab, BFormFile,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email, password,confirmed } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import { slugify } from '@/@fake-db/utils'
import axios from '@axios'

export default {
    components: {
        BSidebar,
        BForm,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BFormInvalidFeedback,
        BButton,
        vSelect,
        ValidationProvider,
        ValidationObserver,
        BTabs, BTab,
        BFormFile,
    },
    directives: {
        Ripple,
    },
    model: {
        prop: 'isFloorplanFormSidebarActive',
        event: 'update:is-floorplan-form-sidebar-active',
    },
    props: {
        isFloorplanFormSidebarActive: {
            type: Boolean,
            required: true,
        },
        building: {
            type: Object,
        },
        langsData:{
            type: Array
        }
    },
    computed: {
        currentLocale() {
            return this.$i18n.locale
        },
    },
    setup(props, { emit }) {
        const userStorage = JSON.parse(localStorage.getItem('userData'))
        const blankData = {
            building_id: props?.building?.id,
            created_by: userStorage?.id || null,
            updated_by: userStorage?.id || null,
            title: {},
            image: null
        }

        const Data = ref({ ...blankData })

        const resetData = () => {
        Data.value = blankData
        }

        const getData = (data) => {
            Data.value.created_by = userStorage?.id || null,
            Data.value.updated_by = userStorage?.id || null,
            Data.value.title = {}
            Data.value.image =  null
            Data.value.building_id = data.id
        }

        const onSubmit = async () => {
            const formData = new FormData();
            formData.append('data', JSON.stringify(Data.value))
            formData.append('imgFile', Data.value.image)

            await axios.post('/house-pin/v1/floorplan/add', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then((response) => {
                emit('update:is-floorplan-form-sidebar-active', false)
                emit('refetch-data')
            })
        }

        const {
            refFormObserver,
            getValidationState,
            resetForm,
        } = formValidation(resetData)

        return {
            refFormObserver,
            getValidationState,
            resetForm,
            Data,
            resetData,
            onSubmit,
            getData,
        }
    }
}
</script>